module.exports = __webpack_public_path__ + "img/saxophone6.087c1ef4.png";